export default __webpack_public_path__ + "static/simplex-example-a8f7fcc8a6661cc72e9c3d1f5c3f00a8.png";